import React from 'react';
import './Spacer.css'

function Spacer() {
  return (
    <div className='bg-blacl'>
        <div className='spacer w-50 bg-light mx-auto'></div>
    </div>
  )
}

export default Spacer